<template>
  <div>
    <i>
      <span v-if="creationTime">{{ $t("registered") + ": " + creationTime }} </span>
      <br />
      <span v-if="lastLogin">{{ $t("lastLogin") + ": " + lastLogin }}</span>
    </i>
  </div>
</template>

<script>
import { functions } from "@/firebase";
export default {
  name: "LastLoginInformation",
  props: {
    uid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      data: {},
    };
  },
  computed: {
    creationTime() {
      if (this.data.creationTime) {
        return new Date(this.data.creationTime).toLocaleDateString("de-DE");
      }
      return null;
    },
    lastLogin() {
      if (this.data.lastLogin) {
        let date = new Date(this.data.lastLogin).toLocaleDateString("de-DE");
        if (date == new Date().toLocaleDateString("de-DE")) {
          date = new Date(this.data.lastLogin).toLocaleTimeString("de-DE") + ", " + date;
        }
        return date;
      }
      return null;
    },
  },
  watch: {
    uid: {
      immediate: true,
      async handler(uid) {
        if (uid != "") {
          this.data = (
            await functions.httpsCallable("GetLastLoginInformation")({
              uid: uid,
            })
          ).data;
        }
      },
    },
  },
};
</script>

<style></style>
